import React, { useState } from 'react';
import axios from 'axios';
import { baseAPI } from '../../../../../config';
import { toast } from 'react-toastify';
import { Dialog, Transition } from '@headlessui/react';
import { BookmarkIcon } from '@heroicons/react/24/outline';

// Modal para añadir anotación
function AddAnnotationModal({ idExpedient, usuario }) {
  const [isOpen, setIsOpen] = useState(false);
  const [anotacion, setAnotacion] = useState('');
  const [tarea, setTarea] = useState('No hay tarea');
  const [loading, setLoading] = useState(false);

  const handleAddAnnotation = async e => {
    e.preventDefault();

    if (!anotacion.trim()) {
      toast.error('La anotación no puede estar vacía');
      return;
    }

    const infoNote = {
      expedient_id: idExpedient,
      anotacion,
      fecha: new Date(),
      user_id: usuario.id,
      creator_name: usuario.name,
      creator_role: usuario.role,
      tarea,
    };

    try {
      setLoading(true);
      await axios.post(`${baseAPI}/annotations/`, infoNote, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      toast.success('Anotación añadida con éxito');
      setAnotacion('');
      setTarea('');
      setIsOpen(false); // Cierra el modal tras añadir
    } catch (error) {
      console.error(error);
      toast.error('Error al añadir la anotación');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        className='w-full px-4 py-2 bg-white border border-slate-200 rounded-lg hover:bg-slate-100 text-sm font-medium transition-colors flex items-center justify-center gap-2'
        onClick={() => setIsOpen(true)}
      >
        <BookmarkIcon className='w-4 h-4' />
        Anotación
      </button>

      <Transition.Root show={isOpen} as={React.Fragment}>
        <Dialog as='div' className='relative z-10' onClose={() => setIsOpen(false)}>
          <Transition.Child
            as={React.Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
          </Transition.Child>

          <div className='fixed inset-0 z-10 overflow-y-auto'>
            <div className='flex min-h-full items-center justify-center p-4 text-center sm:p-6'>
              <Transition.Child
                as={React.Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-lg bg-white p-6 shadow-xl transition-all'>
                  <Dialog.Title className='text-lg font-medium text-gray-900'>Añadir nueva anotación</Dialog.Title>
                  <form className='mt-4' onSubmit={handleAddAnnotation}>
                    <div className='mb-4'>
                      <label className='block text-sm font-semibold text-gray-700'>Nueva anotación</label>
                      <textarea
                        className='w-full mt-2 p-3 rounded-lg border border-gray-300 focus:ring-indigo-500 focus:border-indigo-500'
                        rows='4'
                        placeholder='Escribe aquí tu anotación'
                        value={anotacion}
                        onChange={e => setAnotacion(e.target.value)}
                      />
                    </div>
                    <div className='flex items-center mb-5'>
                      <label className='block text-sm font-semibold text-gray-700 mr-3'>
                        {usuario.role === 'admin' ? '¿Es una tarea para el cliente?' : '¿Es una tarea para el equipo?'}
                      </label>
                      <input
                        type='checkbox'
                        className='h-4 w-4 text-indigo-600'
                        checked={tarea === 'Pendiente'}
                        onChange={() => setTarea(prev => (prev === 'Pendiente' ? '' : 'Pendiente'))}
                      />
                    </div>
                    <button
                      type='submit'
                      disabled={loading}
                      className={`w-full py-2 px-4 text-white bg-blue-600 rounded-lg shadow-md hover:bg-blue-700 transition ${
                        loading ? 'opacity-50 cursor-not-allowed' : ''
                      }`}
                    >
                      {loading ? 'Añadiendo...' : 'Añadir anotación'}
                    </button>
                  </form>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

export default AddAnnotationModal;
